import { render, staticRenderFns } from "./TopTenBrokers.vue?vue&type=template&id=8ce598d2&scoped=true"
import script from "./TopTenBrokers.vue?vue&type=script&lang=js"
export * from "./TopTenBrokers.vue?vue&type=script&lang=js"
import style0 from "./TopTenBrokers.vue?vue&type=style&index=0&id=8ce598d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce598d2",
  null
  
)

export default component.exports